import {Component, OnInit} from '@angular/core';
import {ShipmentService} from "../services/shipment-service";
import {ShipmentsService} from "../services/shipments.service";
import * as moment from "moment/moment";
import {ActivatedRoute} from "@angular/router";
import {combineLatest} from "rxjs";
import {UsersService} from "@hassel-it/angular-common";

@Component({
    selector: 'app-shipment-utilities',
    templateUrl: './shipment-utilities.component.html',
    styleUrls: ['./shipment-utilities.component.scss']
})


export class ShipmentUtilitiesComponent implements OnInit {

    carriers: any[] = [
        {id: '10', name: 'Danske Fragtmænd'},
        {id: '11', name: 'GLS'},
    ];

    public endIfDayParam = {
        automatic: true,
        carrier_code: null, date: moment()}
    protected loading: boolean;
    protected user: any;
    protected userKey: any;
    protected branch: any;

    constructor(
        public usersService: UsersService,
        public shipmentsService: ShipmentsService,
        public activatedRoute: ActivatedRoute,
    ) {
    }

    ngOnInit(): void {

        combineLatest([
            this.activatedRoute.queryParams,
            this.usersService.getCurrentUser(),
        ]).subscribe(([params, user]) => {
            this.user = user;
            this.userKey = user.username.split('@')[0];
            const branchField = user.custom_fields.find((item) => {
                return item.key === 'branch'
            });

            if (branchField && branchField.value) {
                this.branch = branchField.value;
            }
        });
    }


    endOfDay() {

        this.loading = true;
        // tslint:disable-next-line:max-line-length
        this.shipmentsService.printEndOfDay(this.endIfDayParam.carrier_code, this.branch, this.endIfDayParam.date, this.endIfDayParam.automatic).subscribe((response) => {
            const url = window.URL.createObjectURL(response);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'end-of-day.pdf';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            this.loading = false;
        })
    }

    protected startDateChanged($event: moment.Moment) {
        this.endIfDayParam.date = $event;
    }
}
